module.exports = __webpack_public_path__ + "static/placeholder-email icon-3d4f8610f3d5b8e150c289ccb52a9bf6.png";